import { type ReactElement, useRef, useState } from 'react';
import { InView } from 'react-intersection-observer';

import { BenefitsGrid } from '../components/BenefitsGrid/BenefitsGrid';
import { BookChapters } from '../components/BookChapters/BookChapters';
import { Comparison } from '../components/Comparison/Comparison';
import { FAQ } from '../components/FAQ/FAQ';
import { Features } from '../components/Features/Features';
import { Feedback } from '../components/Feedback/Feedback';
import { Hero } from '../components/Hero/Hero';
import { Pricing } from '../components/Pricing/Pricing';
import { StatsStory } from '../components/StatsStory/StatsStory';
import { StickyBuyButton } from '../components/StickyBuyButton/StickyBuyButton';
import Why from '../components/Why/Why';
import { Wrapper } from './TenerifeLandingView.styled';

export const TenerifeLandingView = (): ReactElement => {
  const [isHeroInView, setIsHeroInView] = useState(false);
  const [isPricingInView, setIsPricingInView] = useState(false);
  const [isFooterInView, setIsFooterInView] = useState(false);
  const pricingRef = useRef<HTMLDivElement>(null);
  const bookChaptersRef = useRef<HTMLDivElement>(null);

  const handleScrollToPricing = () => {
    pricingRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScrollToContent = () => {
    bookChaptersRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <Wrapper>
        <InView rootMargin="-100px" onChange={setIsHeroInView}>
          <Hero
            onCallToActionClick={handleScrollToPricing}
            onSecondaryActionClick={handleScrollToContent}
          />
        </InView>
        <div ref={bookChaptersRef}>
          <BookChapters />
        </div>
        <BenefitsGrid />
        <StatsStory />
        <Features />
        <Comparison />
        <InView onChange={setIsPricingInView}>
          <div ref={pricingRef}>
            <Pricing />
          </div>
        </InView>
        <Feedback />
        <Why />
        <FAQ />
        <InView
          rootMargin="-100px"
          onChange={(inView, entry) => {
            const isScrollingUp =
              entry.boundingClientRect.y > entry.rootBounds?.y;
            setIsFooterInView(inView || !isScrollingUp);
          }}
        >
          <div />
        </InView>
      </Wrapper>
      <StickyBuyButton
        isVisible={!isHeroInView && !isPricingInView && !isFooterInView}
        onClick={handleScrollToPricing}
      />
    </>
  );
};
